import { ChangeEvent, cloneElement, Component, ReactElement } from 'react';

type Props = {
  value: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string | number) => void;
  children: ReactElement<any>;
};

type State = {
  value: string | number;
};

//
// 本来はStateless Function Componentで充分だが、日本語IMEのためにStateを利用している
//
class ValueManage extends Component<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.onChange = this.onChange.bind(this);
  }

  public componentWillReceiveProps (nextProps: Props) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  public onChange (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = e.currentTarget.value;

    this.setState ({ value });
    this.props.onChange(e, value);
  }

  public render () {
    const value = this.state.value;
    const children = this.props.children;
    const onChange = this.onChange;

    return cloneElement(children, { ...children.props, value, onChange });
  }
}

export default ValueManage;
